import styled from '@emotion/styled'

// 提示框的描述内容样式
const StyledDescription = styled.div`
  padding: 12px;
  width: 100%;
  color: #526484;
  /* border:1px solid green; */
  font-size: 14px;
`

export default StyledDescription
